import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { TextField, CheckboxInput, Row, Button, Field, Label, ToolTip, Tip, ButtonLinkExternal, CollapsiblePanel }  from '../../generic'
import TextInput from '../../generic/fields/TextInput'
import RadioInput from '../../generic/fields/RadioInput'
import kit from '../../../images/swag-toolkit-2020.jpg';
import { validRadio } from '../../../helpers/check-required-fields';
import styled from 'styled-components';

const Segment = styled.div`
  margin-bottom: 16px;
`

class Swag extends Component {
  constructor(props) {
    super(props)
    this.state = {
      initiallyHadAddress: validRadio(props.userEvent.swag, true)
    }
  }
  render() {
    const { userEvent, currentUser, onChange } = this.props
    return (
      <React.Fragment>
        <h1>Host Perks</h1>
        <p>Thank you for being a spark in your community! We'd like to offer you a free gift and optional financial support to help you with your event.</p>

        <CollapsiblePanel title="Free Gift" showPrompt="Show" hidePrompt="Hide">
          <Segment>
            <Row className="twoCol">
              <div>
                <p>Sharing food is often an important part of gathering people together and in that light we'd like to give you a custom branded re-usable beeswax wrap and snack-bag. To recognize your energy to bring people together, and identify you as the host on the day of your event, we've included an enamel lapel pin. Enjoy!</p>
                <div className="mobile-only">
                 <img style={{width: '100%'}} src={kit} alt="Gift package contents" />
                </div>
                {/*<p><strong>Your toolkit includes:</strong></p>
                <ul>
                 <li>Lunch tote</li>
                 <li>Event decor</li>
                 <li>Banner &amp; poster</li>
                 <li>Guidebook</li>
                 <li>Conversation starter deck</li>
                </ul>
                <p style={{marginBottom: '32px'}}>You can claim your gift until July 28, or until we run out. Limit one gift per host.</p>*/}
                <Field name="userEvent[swag]" error={false} required={true}>
                 <Label value="Would you like an On the Table Host Gift?" />
                 <div>
                   <RadioInput name="userEvent[swag]" onChange={onChange} checked={validRadio(userEvent.swag, true)} value={true} label="Yes, please!" />
                   <RadioInput name="userEvent[swag]" onChange={onChange} checked={validRadio(userEvent.swag, false)} value={false} label="No thanks" style={{ marginLeft: '20px' }} />
                 </div>
                </Field>
                {validRadio(userEvent.swag, true) && (
                 <React.Fragment>
                   {this.state.initiallyHadAddress && <Tip small="true" nodismiss="true">We’ve recorded your shipping address as shown below. You can only change it before September 30, after which delivery is locked.</Tip>}
                   <h2 style={{margin: '30px 0 20px'}}>Send my gift to:</h2>
                   <Field name="userEvent[swag_address_1]" error={false}>
                     <Label value="Address 1" required={true} />
                     <TextInput value={userEvent.swag_address_1} onChange={onChange} />
                   </Field>
                   <Field name="userEvent[swag_address_2]" error={false}>
                     <Label value="Address 2" />
                     <TextInput value={userEvent.swag_address_2} onChange={onChange} />
                   </Field>
                   <Field name="userEvent[swag_city]" error={false}>
                     <Label value="City" required={true} />
                     <TextInput value={userEvent.swag_city} onChange={onChange} />
                   </Field>
                   <Field name="userEvent[swag_province]" error={false} hint="Sorry but we can only provide gifts within British Columbia.">
                     <Label value="Province" required={true} />
                     <TextInput disabled value="British Columbia" />
                   </Field>
                   <Field name="userEvent[swag_postal]" error={false} hint="E.g. V5Y 1V4">
                     <Label value="Postal Code" required={true} />
                     <TextInput value={userEvent.swag_postal} onChange={onChange} />
                   </Field>
                    <Tip id="invite-block" nodismiss="true">
                     <p>Delivery expected mid October.</p>
                    </Tip>
                 </React.Fragment>
                )}
                <ButtonLinkExternal href="/resources/">Visit How to Host &rarr;</ButtonLinkExternal>
              </div>
              <div className="no-mobile">
                <img style={{width: '100%'}} src={kit} alt="Gift package contents" />
              </div>
            </Row>
          </Segment>
        </CollapsiblePanel>

        <CollapsiblePanel title="Financial Support" showPrompt="Show" hidePrompt="Hide">
          <Segment>
            <div style={{ maxWidth: '500px' }}>
              <p>Vancouver Foundation will grant up to $100 to individual hosts for supporting their event needs (eg. refreshments or snacks, posters, virtual licenses, space rentals) based on fulfilling eligibility requirements below. This grant is available to individuals and individuals within organizations.</p>
              <Field name="userEvent[grant_amount]">
                <Label value="How much do you need? (Up to $100)" required={true} />
                <TextInput value={userEvent.grant_amount} onChange={onChange} style={{ maxWidth: '125px' }} />
              </Field>
              <Field name="userEvent[grant_purpose]">
                <Label value="How will you use this grant?" required={true} />
                <TextInput value={userEvent.grant_purpose} onChange={onChange} />
              </Field>
              <Field name="userEvent[grant_agree]">
                <CheckboxInput label="By submitting this request, I confirm that:" checked={validRadio(userEvent.grant_agree, true)}  onChange={onChange} />
                <ul>
                  <li>I live in British Columbia.</li>
                  <li>I agree to follow health and authority guidelines current on the day of my gathering.</li>
                  <li>I will not use this grant for the purchase of alcohol or marijuana.</li>
                  <li>If my event does not happen, I will return the grant to Vancouver Foundation.</li>
                </ul>
              </Field>
              <p>If approved, grant funds will be sent within approximately two weeks by Interac transfer to your registered email address.</p>
            </div>
          </Segment>
        </CollapsiblePanel>

      </React.Fragment>
    )
  }
}

export default Swag

